import { render, staticRenderFns } from "./main-setup.vue?vue&type=template&id=083b8406&"
import script from "./main-setup.vue?vue&type=script&lang=js&"
export * from "./main-setup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports